import React from "react";
import ModalBootstrap from "../modal/modal_bootstrap";

const AboutPaymentModal = () => {
  const previewContent = (
    <p className="text-fz-14px text-fw-bold text-black-50 mb-2 d-inline-block">
      <span
        id="about_payment"
        className="bg-secondary text-white p-1 mr-2"
        style={{ borderRadius: "30px" }}
      >
        ？
      </span>
      決済手数料について
    </p>
  );

  const modalTitle = "決済手数料について";

  const modalContent = (
    <React.Fragment>
      <h6 className="text-fw-bold text-center mb-3_5" />
      <h5 className="mt-5 g-mt-40">イベント参加料　クレジットカード決済代行</h5>
      <div className="card bg-light mt-2 mb-5">
        <div className="card-body">
          <h5 className="mt-3 mb-3">決済手数料</h5>
          <p style={{ fontSize: "20px" }}>
            イベント売上額の8% + 出金手数料330円
          </p>
        </div>
      </div>
      <h5 className="g-mt-20 bold">決済代行売上の引き出しについて</h5>
      <p className="small">
        引き出し時に「イベント売り上げ額 +
        特典メンバー会費売り上げ額」から「つなげーと手数料8% +
        出金手数料330円」を引いた引き出し可能額が振り込まれます。
      </p>
      <p className="small">
        出金手数料は、出金申請1件ごとにかかります（銀行振込にかかる費用に加え、当社の事務手数料を含みます）。同一口座あての複数の出金申請は、まとめて1回でお振込みする場合がありますが、その場合も出金手数料は出金申請1件ごとに申し受けます。
      </p>
      <p className="small">
        サークルの「管理人メニュー」の「サークル売り上げ管理」より引き出し申請を行ってください。
      </p>
      <p className="small">
        事前にご利用サークルにおいて振込先の銀行口座の登録が必要です。
      </p>
      <h5 className="mt-5 g-mt-20 bold">イベント参加者のキャンセルについて</h5>
      <p className="small">
        ・参加予定者が参加をキャンセルした場合のお支払い金額の返金条件については、イベントごとに異なります。イベント詳細ページにてご確認ください。参加者よりイベントのキャンセルがあった場合、イベント運営者にはキャンセルと返金の旨、システムより通知します。
      </p>
      <h5 className="mt-5 g-mt-20 bold">
        イベント運営者都合のキャンセルについて
      </h5>
      <p className="small">
        ・イベント運営者側の都合でイベントをキャンセルする場合は、決済された参加料金は全額、参加予定者に返金いたします。
      </p>
      <p className="small">
        ・返金手数料として、決済手数料分（8%）をサークル運営者から当社へお支払いください。決済手数料の支払いにあたっては、当社からの未払い金額がある場合は相殺にて、未払い金額がない場合は当社指定口座への振込にてお願いいたします。
      </p>
    </React.Fragment>
  );

  return (
    <ModalBootstrap
      previewContent={previewContent}
      modalTitle={modalTitle}
      modalContent={modalContent}
      isMaxWidth={true}
    />
  );
};

export default AboutPaymentModal;
